import { render, staticRenderFns } from "./ConfirmDeleteModal.vue?vue&type=template&id=5f221859&scoped=true&"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeleteModal.vue?vue&type=style&index=0&id=5f221859&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f221859",
  null
  
)

export default component.exports